module.exports = new __parcel__URL__("hedgehog.4cc9668b.svg").toString();